import { ReactNode } from 'react';
import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';
import { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DialogFlexSales from './DialogFlexSales';

const DialogContentStyled = styled(DialogContent)<{ width?: string }>`
  ${({ width }) =>
    width &&
    `
  tbody {
    width: ${width};
  }
  `}
`;

const LoadingContainer = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  justify-content: center;
  min-height: 160px;
`;

interface DialogFormProps {
  children: ReactNode;
  title: string;
  notFound?: boolean;
  loading?: boolean;
  maxWidth?: DialogProps['maxWidth'];
  width?: string;
  fullScreen?: boolean;
}

// TODO: agrega lógica de Not Found
const DialogForm = ({
  children,
  title,
  notFound,
  loading,
  width,
  maxWidth,
  fullScreen,
}: DialogFormProps) => {
  const { t } = useTranslation();

  return (
    <DialogFlexSales open maxWidth={maxWidth} fullScreen={fullScreen} dialogTitle={title}>
      <DialogContentStyled width={width}>
        {!notFound && !loading && children}
        {loading && (
          <LoadingContainer>
            <CircularProgress />
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                {t('visual.loadingState.title')}
              </Typography>
            </Box>
          </LoadingContainer>
        )}
      </DialogContentStyled>
    </DialogFlexSales>
  );
};

export default DialogForm;
